import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormService } from '../service';
import { TextInputDataComponent } from '../../../../../../components/text-input/text-input.component';
import { PhoneNumberInputComponent } from '../../../../../../components/phone-number-input/phone-number-input.component';
import { EmailInputFieldComponent } from '../../../../../../components/email-input-field/email-input-field.component';
import { SummaryComponent } from '../summary/summary.component';
import { CheckboxComponent } from '../../../../../../components/checkbox/checkbox.component';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { SelectComponent } from '../../../../../../components/select/select.component';
const moment = _rollupMoment || _moment;
import { TranslocoModule, TranslocoService } from "@jsverse/transloco";
import { CommonModule } from '@angular/common';
import {
  MatDialog,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { BookingConfigService } from '../../../../../../services/booking-config.service';
import { TopNavbarComponent } from '../../../../../components/top-navbar/top-navbar.component';
import { AuthService } from '../../../../../../../services/auth.service';
import { ShuttelbussService } from '../../../../../../../services/shuttlebuss.service';
import { SelfServiceService } from '../../../../.././../../services/self-service.service';
import { ConfirmModalComponent } from './../../../../../../components/confirm-modal/confirm-modal.component';
import { CheckoutServices } from '../../../../../../services/checkout.service';
import { TermsAndConditionsComponent } from '../../../../../../organizations/pages/terms-and-conditions/terms-and-conditions.component';

@Component({
  standalone: true,
  selector: 'app-details',
  imports: [
    TextInputDataComponent,
    PhoneNumberInputComponent,
    EmailInputFieldComponent,
    SummaryComponent,
    CheckboxComponent,
    SelectComponent,
    CommonModule,
    TranslocoModule,
    TopNavbarComponent
  ],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})
export class DetailsComponent {
  detailsGroup: any;
  site: string = '';
  additionalServicesEnabled: boolean | null = false;
  optionsConfig: any;
  parkType: string = '';
  @Input() stepper: MatStepper | null = null;
  parkingTypeId: string = '';
  parkTypeForDisabled: boolean = false;
  passengers = [
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
  ]
  checkInBagage: any = []
  arriveAtParkingOptions: any = [];
  parkingSpaceSizeText = '(2,5 x 5m)';
  showSubscription: boolean = false;
  isParkingPermitUser: boolean = sessionStorage.getItem('isParkingPermitUser') === 'true';
  organizationId: string = '';
  showHeightRequirement: boolean = false;
  timeoutError: boolean;
  parkingFrom: any = null;
  parkingTo: any = null;
  selectedParking: any = null;

  constructor(
    private _formService: FormService,
    private translocoService: TranslocoService,
    public dialog: MatDialog,
    private bookingConfigService: BookingConfigService,
    public authService: AuthService,
    public shuttelbussService: ShuttelbussService,
    private selfService: SelfServiceService,
    private checkoutService: CheckoutServices
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.detailsGroup = _formService.getForm().get('details');
  }

  public ngOnInit() {
    const config = this.bookingConfigService.getConfig();
    this.site = this.site;
    this.organizationId = config.orgId?.toLowerCase();
    this.additionalServicesEnabled = config?.additionalServices;

    if ('options' in config) {
      const env: any = config;
      if ('detailsFields' in env.options) {
        this.optionsConfig = env.options.detailsFields;
      }
    }

    this.detailsGroup.controls.regNr.valueChanges.subscribe(value => {
      if (!value) return;
      if (this.organizationId?.toUpperCase() !== '942CE067-7848-4441-B746-8F6EED7395BB' && this.organizationId?.toUpperCase() !== 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B') {
        return;
      }
      this.selfService.checkExistingOrder(value, this.organizationId).then((result: any) => {
        if (result && result.parkingFromUTC && result.parkingToUTC) {
          const fromDate = new Date(result.parkingFromUTC);
          const toDate = new Date(result.parkingToUTC)
          this.parkingFrom = this.formatDateToSwedishLocal(fromDate);
          this.parkingTo = this.formatDateToSwedishLocal(toDate);
          this._formService.searchStartDate = new Date(this.parkingFrom);
          this._formService.searchEndDate = new Date(this.parkingTo);
          this._formService.getForm().get('parkingGroup').controls['departureDate'].setValue(new Date(this.parkingFrom));
          this._formService.getForm().get('parkingGroup').controls['arrivalDate'].setValue(new Date(this.parkingTo));
          // call checkprice using parkingto and gatename
          this.getOrder(result.orderId);
        } else {
          return;
        }
      })
    });

    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: 1, viewValue: this.translocoService.translate("PARKIFLY.FORM.YES") },
          { value: 0, viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]

        if (this.authService.loggedIn() && this.optionsConfig?.luggage !== false && !this.detailsGroup.controls.onlyHandBaggage.value) {
          this.detailsGroup.controls.onlyHandBaggage.setValue(0);
        }
      });

    this._formService.selectedDepartureFlight.subscribe((change: any) => {
      if (change) {
        this.populateParkingStartTime(change.departureTime?.scheduled);
      }
    });

    if (this._formService.getForm().get('parking')) {
      this._formService.getForm().get('parking').controls.selectedParking.valueChanges.subscribe((change: any) => {
        if (change) {
          this.parkType = change.name;
          this.parkingTypeId = change.id;
          this.parkTypeForDisabled = change.disabledParkingSpace;
          this.showHeightRequirement = this.shouldShowHeightRequirement();

          if (this.parkType.toLowerCase() === 'flygets p1 storbil') {
            this.detailsGroup.controls.parkingspacesize.setValue(true);
          } else {
            this.detailsGroup.controls.parkingspacesize.setValue(false);
          }

          if (change.id == '5d2c7728-6944-45a6-a64e-b16f00e5e3b3') {
            this.parkingSpaceSizeText = '(2.8 x 6 m)';
          } else {
            this.parkingSpaceSizeText = '(2,5 x 5m)';
          }
        }
      });
    }

    if (JSON.parse(sessionStorage.getItem('showSubscription')) == true) {
      this.showSubscription = true;
    }

    // Set empty/valid values for parking permit users
    if (this.isParkingPermitUser) {
      this.detailsGroup.patchValue({
        regNr: '',
        firstname: '',
        lastname: '',
        email: '',
        cellular: '',
        persons: '',
        onlyHandBaggage: '',
        comment: '',
        consent: true,
        parkingspacesize: true
      });
      this.detailsGroup.clearValidators();
      this.detailsGroup.updateValueAndValidity();
      return;
    }

    //auto-complete
    if (this.authService.loggedIn()) {
      let email = this.authService.getUserEmail();
      this.shuttelbussService.loadMyPageData().subscribe(user => {
        if (this.site !== 'tui' && this.site !== 'nazar') { this.detailsGroup.controls.firstname.setValue(user.firstname); }
        this.detailsGroup.controls.lastname.setValue(user.lastname);
        this.detailsGroup.controls.email.setValue(email);
        this.detailsGroup.controls.cellular.setValue(user.mobile);
        this.detailsGroup.controls.persons?.setValue(this.showSubscription == true ? '' : '1');
        this.detailsGroup.controls.parkingspacesize?.setValue(true);
        this.detailsGroup.controls.consent?.setValue(true);
      });
    }

  }

  openConfirmModal() {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        text: {
          sv: 'Vi har hittat en påbörjad bokning för detta fordon och priset har uppdaterats enligt de uppgifterna. Klicka för att fortsätta din bokning.',
          en: 'We have found an existing order for this vehicle and price has changed according to that information. Confirm and continue your booking.'
        },
        org: 'driveup'
      }
    });
  }

  openBookingAlreadyExistsModal() {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    this.dialog.open(ConfirmModalComponent, {
      data: {
        text: {
          sv: 'Du har redan en bokning under denna tidsperiod. Vänligen sök i din mail efter tidigare bekräftelse eller välj en annan tid och fortsätt med bokningen.',
          en: 'You already have a booking during this time period. Please check your mail for earlier confirmation or choose a different time and continue your booking.'
        },
        org: 'driveup'
      }
    });
  }

  openHandBagageModal() {
    this.dialog.open(HandBagageModal);
  }

  openTermsModal() {
    this.dialog.open(TermsModal, {
      maxHeight: '85vh',
      panelClass: 'terms-modal-dialog'
    });
  }

  openHotelInfoModal() {
    this.dialog.open(QualityInfoModal);
  }

  regToUpper() {
    let raw = this.detailsGroup.controls["regNr"]?._pendingValue ?? '';
    let formatted = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.detailsGroup.controls["regNr"].setValue(formatted, { emitEvent: false });
  }

  bookingNrToUpper() {
    if (!this.detailsGroup.controls["bookingNumber"]) return;
    let raw = this.detailsGroup.controls["bookingNumber"]?._pendingValue ?? '';
    let formatted = raw.toUpperCase().replace(/\s+/g, '');
    this.detailsGroup.controls["bookingNumber"].setValue(formatted, { emitEvent: false });
  }

  goBack() {
    this.stepper?.previous();
  }

  triggerParkingSpaceSize() {
    this.detailsGroup.controls.parkingspacesize.setValue(!this.detailsGroup.controls.parkingspacesize.value);
  }

  triggerConsent() {
    this.detailsGroup.controls.consent.setValue(!this.detailsGroup.controls.consent.value);
  }

  triggerHotelInfoConsent() {
    this.detailsGroup.controls.hotelInfoConsent.setValue(!this.detailsGroup.controls.hotelInfoConsent.value);
  }

  shouldShowHeightRequirement(): boolean {
    const qualityOrgId = '942ce067-7848-4441-b746-8f6eed7395bb';
    const skavstaOrgId = 'dc3e5c36-a4f7-4886-98f2-4833ea27f84b';
    const skavstaP2ElbilId = '1a8879f4-a294-455b-97eb-b16f00e5e30a';
    const skavstaP2InomhusId = 'eacc8615-81a4-4013-a7e5-b16f00e5e270';

    if (this.organizationId?.toLowerCase() === qualityOrgId) {
      return true;
    }

    if (this.organizationId?.toLowerCase() === skavstaOrgId) {
      if (this.parkingTypeId === skavstaP2ElbilId || this.parkingTypeId === skavstaP2InomhusId) {
        return true;
      }
    }

    return false;
  }

  private populateParkingStartTime(startTime: string) {
    let options: any = []
    let time = 0;
    const translations = [
      'TIME.1_HOUR_BEFORE',
      'TIME.1.25_HOUR_BEFORE',
      'TIME.1.5_HOUR_BEFORE',
      'TIME.1.75_HOUR_BEFORE',
      'TIME.2_HOURS_BEFORE',
      'TIME.2.25_HOURS_BEFORE',
      'TIME.2.5_HOURS_BEFORE',
      'TIME.2.75_HOURS_BEFORE',
      'TIME.3_HOURS_BEFORE',
      'TIME.3.25_HOURS_BEFORE',
      'TIME.3.5_HOURS_BEFORE',
      'TIME.3.75_HOURS_BEFORE',
      'TIME.4_HOURS_BEFORE',
      'TIME.4.25_HOURS_BEFORE',
      'TIME.4.5_HOURS_BEFORE'
    ]

    this.arriveAtParkingOptions = options.reverse();
  }

  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  formatDateToSwedishLocal(sourceUtc: string | Date): string {
    const date = typeof sourceUtc === 'string'
      ? new Date(sourceUtc)
      : sourceUtc;

    const parts = new Intl.DateTimeFormat('sv-SE', {
      timeZone: 'Europe/Stockholm',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(date);

    const get = (type: string) =>
      parts.find(p => p.type === type)?.value;

    return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:00`;
  }

  getOrder(orderId: string) {
    this.checkoutService
      .getOrder(orderId)
      .subscribe(
        (result: any) => {
          const parkingControl = this._formService.getForm().get('parking')?.get('selectedParking');
          if (parkingControl && parkingControl.value) {
            parkingControl.setValue({
              ...parkingControl.value,
              totalPrice: result.totalPriceIncVat,
              price: result.totalPriceExVat,
              vat: result.totalVat
            });
          }
          this._formService.selectedParking.totalPrice = result.totalPriceIncVat;
          this._formService.selectedParking.price = result.totalPriceExVat;
          this._formService.selectedParking.vat = result.totalVat;
          this.openConfirmModal();
        })
  }

}

@Component({
  selector: 'hand-bagage-modal',
  templateUrl: 'hand-bagage-modal.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose]
})
export class HandBagageModal {
  constructor() { }
}

@Component({
  selector: 'terms-modal',
  templateUrl: 'terms-modal.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose, TermsAndConditionsComponent]
})
export class TermsModal {
  constructor() { }
}

@Component({
  selector: 'quality-info-modal',
  templateUrl: 'quality-info-modal.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose]
})
export class QualityInfoModal {
  constructor() { }
}